// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PoweredBy-root{display:flex;align-items:center;flex-direction:column}.PoweredBy-texts{display:flex;align-items:center;justify-content:center;margin-top:33px}", ""]);
// Exports
module.exports = exports;
